jQuery( document ).ready(function() {
  var giftMessage = localStorage.getItem('giftMessage');
  if (giftMessage) {
    document.getElementById('flexibleInputField').value = giftMessage;
    document.getElementById('all-items').checked = true;
    document.querySelector('.gift-message-content').style.display = "block";
  }
});
var countText = "/70 caractères autorisés";
var cart_note_count = document.querySelector("#note-count");
var displayBox = false;
cart_note_count && (cart_note_count.innerHTML = "0"+countText);
document.querySelector('#CartSpecialInstructions')?.addEventListener('input', function() {
  cart_note_count && (cart_note_count.innerHTML = this.value.length+countText);
  this.value = this.value.replace(/(?:[`~<>;:"\/\[\]\|{}()=_+-])|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]){3}|[!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]/g, '');
});
var displayBox = false;
var selectedAllClick = false;
 var selectAllInput = 0;
var giftMessageValid = true;
var agreeCartCond = false;

var charactersPerLine = document.getElementById("charactersPerLine") ? document.getElementById("charactersPerLine").value : "";
var maxLines = document.getElementById("maxLines") ? document.getElementById("maxLines").value : "";
var textOutput="";
var onPaste=false;
var widthPerCharacter=10;

function formatTextAsRequired() {
  var textInput=document.getElementById("flexibleInputField").value;
  var inputAsRows=textInput.split("\n");
  var inputAsOneLine=textInput.replace(/(\r\n\t|\n|\r\t)/gm,"");
  var cursorPositionOnInput=document.getElementById("flexibleInputField").selectionStart;
  var cursorOffsetAfterOutput=0;

  var visibleCharactersPerLine=Math.floor((document.getElementById("flexibleInputField").offsetWidth)/9);
  var additionalTextAreaRows=0;

  var totalRows=inputAsRows.length;
  var row;
  for (row = 0; row < totalRows; ++row) {
    if(inputAsRows[row].length>charactersPerLine){
      if (inputAsRows[row+1] === undefined) {
        inputAsRows[row+1]="";
        totalRows++;
        }
      inputAsRows[row+1]=inputAsRows[row].substring(charactersPerLine)+inputAsRows[row+1];
      inputAsRows[row]=inputAsRows[row].substring(0,charactersPerLine);
      var newOutput=inputAsRows.join("\n");
      if(newOutput.substr(cursorPositionOnInput-1,1)=="\n"){
        cursorOffsetAfterOutput=1; }
      }
    if(inputAsRows[row].length>visibleCharactersPerLine){
      additionalTextAreaRows=additionalTextAreaRows+Math.floor(inputAsRows[row].length/visibleCharactersPerLine);
      }

    }

  if(inputAsRows.length<=maxLines && inputAsOneLine.length<=(maxLines*charactersPerLine)){
    textOutput=inputAsRows.join("\n");
    document.getElementById("flexibleInputField").rows=inputAsRows.length+additionalTextAreaRows;
    document.getElementById("errors").innerHTML="";
    document.getElementById("count").innerHTML=inputAsOneLine.length+"/"+(maxLines*charactersPerLine) + " caractères autorisés";
    if(onPaste){
      cursorOffsetAfterOutput=cursorOffsetOnPaste(textInput,cursorPositionOnInput,totalRows)
      }
    }
    else
    {
    document.getElementById("errors").innerHTML="Vous avez dépassé la limite autorisée de 350 caractères";
    document.getElementById("count").innerHTML="";
    cursorOffsetAfterOutput=-1;
  }
  document.getElementById("flexibleInputField").value=textOutput;
  document.getElementById("flexibleInputField").selectionStart=cursorPositionOnInput+cursorOffsetAfterOutput;
  document.getElementById("flexibleInputField").selectionEnd=cursorPositionOnInput+cursorOffsetAfterOutput;
  onPaste=false;
  showOutput();
}

function countLineBreaks(string,lengthFromStart){
  var left=string.substr(0,lengthFromStart);
  var countOfLinebreaks=(left.split("\n")).length;
  return countOfLinebreaks;
}

function handlePaste(){
  onPaste=true;
}

function cursorOffsetOnPaste(textInput,cursorPositionOnInput,totalRows){
  var countOld=countLineBreaks(textInput,cursorPositionOnInput);
  var countNew=countLineBreaks(textOutput,cursorPositionOnInput+totalRows);
  cursorOffsetAfterOutput=countNew-countOld;
  return cursorOffsetAfterOutput;
}

function updateRestrictions() {
  charactersPerLine=document.getElementById("charactersPerLine").value;
  maxLines=document.getElementById("maxLines").value;
}

function showOutput(){
  var outputHTMLtable="<table>";
  var textInput=document.getElementById("flexibleInputField").value;
  var inputAsRows=textInput.split("\n");
  for(row=0;row<inputAsRows.length;row++)
    {
      outputHTMLtable=outputHTMLtable+"<tr><td>field "+row+":</td><td>"+inputAsRows[row]+"</td></tr>";
    }
  outputHTMLtable=outputHTMLtable+"</table>";
}

function onFocus(){
  var flexibleInputField=document.getElementById("flexibleInputField");
  flexibleInputField.classList.remove("inactive");
  flexibleInputField.classList.add("active");
}
function onBlur(){
  var flexibleInputField=document.getElementById("flexibleInputField");
  flexibleInputField.classList.remove("active");
  flexibleInputField.classList.add("inactive");
  document.getElementById("errors").innerHTML="";
}

$(document).ready(function(){
  var giftMessageValid = true;
  var agreeCartCond = false;
  var displayBox = false;
  document.getElementById("all-items").disabled=false;
  document.querySelector(".gift-item-all").addEventListener("click", function(e){
    const checkbox = document.getElementById("all-items");
    displayBox = checkbox.checked;
    if (displayBox) {
       document.querySelector('.gift-message-content').style.display = "block";
       document.querySelector('.cart .cart_footer_dblock a.btn').classList.add('ongift');
    } else {
       document.querySelector('.gift-message-content').style.display = "none";
       document.querySelector('.cart .cart_footer_dblock a.btn').classList.remove('ongift');
       $("#agreeCart").prop("disabled", false);
       $("#flexibleInputField").val("");
       localStorage.removeItem('giftMessage');
    }
  })
  document.querySelector('#flexibleInputField').addEventListener('input', function(){
    this.value = this.value.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
    this.setAttribute('rows', '5');
    let strGift = this.value;
    let newArr = [];
    let arrayRegExp = ['"', '_', '=', '+', '°', '~', '{', '}', '@', '^', '`', '<', '>', ':', ';', '/', '§', '¨£', '¤', '%', 'µ', '|'];
    
    for(let i = 0; i < strGift.length; i++) {
      if(arrayRegExp.includes(strGift.charAt(i))) {
        newArr.push(strGift.charAt(i));
      }
    }

    if(newArr.length > 0) {
      $('#rchars').text("Votre message contient un ou plusieurs caractères non autorisés [" + newArr + "]");
      giftMessageValid = false;
      $("#agreeCart").prop("checked", false);
      agreeCartCond = false;
      $("#agreeCart").prop("disabled", true);
      $('#rchars').addClass('char-error');
      $('#rchars').css('display', "inline-block");
      $('#rchars').css('background', "#dc354530");
      $('#validationchars').css('display', "none");
      $(this).removeClass("validation-green-border");
    } else {
      localStorage.setItem('giftMessage', strGift);
      giftMessageValid = true;
      $("#agreeCart").prop("disabled", false);
      $('#rchars').removeClass('char-error');
      $('#rchars').css('display', "none");
      $(this).addClass("validation-green-border");
    }
  })
});

$(".cart__items .product-quantity-info").on('click', '.js-cart-product-quantity [data-control]', function(e){
  e.preventDefault();
  let $this = $(this);
  let quantity_parent_selector = $this.parents(".js-cart-product-quantity");
  let input = quantity_parent_selector.find("input");
  let sku = quantity_parent_selector.attr('data-sku');
  let accise_tax = quantity_parent_selector.attr('data-accise-tax');
  let vignette_tax = quantity_parent_selector.attr('data-vignette-tax');
  let direction = $this.attr('data-control');
  let quantity = input.val();
  let current_val;
  if($.isNumeric(quantity) && quantity > 0) {
    if(direction === '+') {
      current_val = ++quantity;
    } else {
      current_val = --quantity;
    }
    input.val(current_val)
  }

  updateTaxes(current_val, sku, accise_tax, vignette_tax);

});

function updateTaxes(quantity,sku, acciseTax, vignetteTax){
  let accise = acciseTax ? acciseTax : 0;
  let vignette = vignetteTax ? vignetteTax : 0;
  let acciseTaxeHiddenInput = $("#accise_tax").val();
  let vignetteTaxHiddenInput = $("#vignette_tax").val();

  // convert string to correct javascript json format ex: [{sku: 1234, value: 4.5}] to [{"sku": 1234, "value": 4.5}]
  let acciseTaxObject = JSON.parse(acciseTaxeHiddenInput.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
  let vignetteTaxObject = JSON.parse(vignetteTaxHiddenInput.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));

  let acciseTaxeIndex = acciseTaxObject.findIndex((obj => obj.sku == sku));
  let vignetteTaxIndex = vignetteTaxObject.findIndex((obj => obj.sku == sku));

  if(acciseTaxObject[acciseTaxeIndex]) acciseTaxObject[acciseTaxeIndex].value = (1 * accise * quantity).toFixed(2) * 1;
  if(vignetteTaxObject[vignetteTaxIndex]) vignetteTaxObject[vignetteTaxIndex].value = (1 * vignette * quantity).toFixed(2) * 1;

  // Before set data on input value we formatting data ex: [{"sku": 1234, "value": 4.5}] to [{sku: 1234, value: 4.5}]
  acciseTaxStringObject = JSON.stringify(acciseTaxObject).replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '$2:');
  vignetteTaxStringObject = JSON.stringify(vignetteTaxObject).replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '$2:');
  $("#accise_tax").val(acciseTaxStringObject);
  $("#vignette_tax").val(vignetteTaxStringObject);

  let kvpairs = [];
  let form = document.getElementById('cartFormSubmit');
  let action = form.action;
  for ( var i = 0; i < form.elements.length; i++ ) {
    let e = form.elements[i];
    kvpairs.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
  }
  let queryString = kvpairs.join("&");

  $.ajax({
    type: "POST",
    url: action,
    data: queryString,
    contentType: "application/x-www-form-urlencoded",
    success: function () {
      if(quantity < 1 ){
        location.reload();
      }
    }
  });
}